import getApiUrl from "../utils/apiUrl";
import fetch from "../utils/mgFetch";

const getBookableVehicles = (token: string, backend: string) => {
    return fetch(`${getApiUrl(backend)}bookable_vehicles`, {
        method: "GET",
        headers: {
            Authorization: `Bearer ${token}`
        }
    }) 
}

export default getBookableVehicles